// const url = "https://softwaretestinginternal.aiodock.com/";
// const url = "/";
const url = "https://invoicing.wisevisionpakistan.com/"
// const url = "http://localhost:2000/"
export default url;
